import { useLayoutEffect, useRef } from 'react'
import { instanceOf, number, shape, string } from 'prop-types'

import preloadPostMedia from '../../../../utilities/preloadPostMedia.js'
import keyPress from '../../../../utilities/keyPress.js'
import CardsSocialCommerceButton from './cards-social-commerce-button.js'
import FeedPost from './feed-post.js'
import Settings from '../../../../../models/settings.js'
import GateContext from '../../../../utilities/gateContext.js'
import Post from '../../../../../models/Post.js'
import Locale from '../../../../../models/Locale.js'

export default function FeedCard({
  additionalStyles,
  feedKey,
  locale,
  observer,
  post,
  settings,
  width,
}) {
  const { gutterSize, socialCommerceButtonPosition } = settings
  const socialCommerceButton = (
    <CardsSocialCommerceButton feedKey={feedKey} post={post} settings={settings} />
  )
  const mainRef = useRef()

  useLayoutEffect(() => {
    const { current } = mainRef
    observer.observe(current)
    return () => {
      observer.unobserve(current)
    }
  }, [observer])

  return (
    <div
      key={`post-${post.key}`}
      ref={mainRef}
      className="bzfy-o-layout__item bzfy-masonry-item"
      data-post-key={post.key}
      onMouseEnter={() => preloadPostMedia(post)}
      style={{
        paddingLeft: gutterSize,
        ...additionalStyles,
      }}
    >
      <GateContext.Consumer>
        {({ openGate }) => (
          <div
            className="bzfy-c-cardflow-post-container bzfy-c-cardflow-post-container--clickable"
            onClick={() => openGate(post)}
            onKeyDown={(e) => keyPress(e, () => openGate(post))}
            role="link"
            tabIndex={0}
            title={locale.getTranslation('openTheGate')}
          >
            <div className="bzfy-c-cardflow-post-container__inner">
              <FeedPost
                feedKey={feedKey}
                post={post}
                settings={settings}
                socialCommerceButton={socialCommerceButton}
                socialCommercePosition={socialCommerceButtonPosition}
                width={width}
              />
            </div>
          </div>
        )}
      </GateContext.Consumer>
    </div>
  )
}

FeedCard.propTypes = {
  additionalStyles: shape(),
  feedKey: string.isRequired,
  locale: instanceOf(Locale).isRequired,
  observer: instanceOf(IntersectionObserver).isRequired,
  post: instanceOf(Post).isRequired,
  settings: instanceOf(Settings).isRequired,
  width: number.isRequired,
}
